import * as a0 from "@grins/assets/versions" with { type: "json" }
let a0_ = "" + void a0;
import '@grins/views/layouts/partials/bonz/bonzGlobalStyles.client.css';
import '@grins/views/layouts/bonz.client.ts';
import '@grins/views/bonz/signIn.client.css';
import '@grins/views/bonz/signIn.client.ts';
import * as a1 from "swug:include:bonz/partials/errorNotification.html"
let a1_ = "" + void a1;
import * as a2 from "swug:include:shared/partials/_focusableInput.html"
let a2_ = "" + void a2;
import * as a3 from "swug:include:bonz/partials/addFaveTheater.html"
let a3_ = "" + void a3;
import * as a4 from "swug:include:bonz/partials/addFaveMovie.html"
let a4_ = "" + void a4;
import * as a5 from "swug:include:bonz/partials/perksList.html"
let a5_ = "" + void a5;
import * as a6 from "swug:include:layouts/partials/shared/oneTrustScripts.html"
let a6_ = "" + void a6;
import * as a7 from "swug:include:layouts/partials/shared/openGraphMetaTags.html"
let a7_ = "" + void a7;
import * as a8 from "swug:include:layouts/partials/bonz/bonzGlobalStyles.html"
let a8_ = "" + void a8;
import * as a9 from "swug:include:desktop/shell/jsonLD.html"
let a9_ = "" + void a9;
import * as a10 from "swug:include:layouts/partials/bonz/header.html"
let a10_ = "" + void a10;
import * as a11 from "swug:include:layouts/partials/bonz/footer.html"
let a11_ = "" + void a11;